import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
 
 // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyDlyrcSiDDDlsi0hGj8je4qrRKZuEIFSas",
    authDomain: "thesciencecapital.firebaseapp.com",
    databaseURL: "https://thesciencecapital.firebaseio.com",
    projectId: "thesciencecapital",
    storageBucket: "thesciencecapital.appspot.com",
    messagingSenderId: "34826205044",
    appId: "1:34826205044:web:eb302fd0e242e7bd325e21",
    measurementId: "G-YFVW5WENY1"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);


const db = firebase.firestore(); // access to the database
const auth = firebase.auth(); // access to the auth functions provided by firebase
const storage = firebase.storage(); //access to the database
const currentUser = auth.currentUser; // currently signed in user

export {
    db,
    auth,
    storage,
    currentUser
}